import './FundList.sass';
import imgFundHeroL from '../assets/fundlist/fund-hero-l.jpg';
import imgEtfHeroL from '../assets/fundlist/etf-hero-l.jpg';
import iconList from '../assets/dividend/list.svg';

import { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router';
import { groupBy, each } from 'lodash';

import Hero from '../components/Hero';
import SlideToggle from 'react-slide-toggle';
import BezierEasing from 'bezier-easing';
import { useStockList, useArticles } from '../api';

import Breadcrumbs from '../components/Breadcrumbs';

import Meta from '../components/Meta';

const bezier = BezierEasing(0.68, 0, 0.265, 1);

const FundList = (props) => {
	const location = useLocation();
	const [slideAll, setSlideAll] = useState(true);

	const dict = useMemo(() => {
		return {
			onshore: {
				pathName: '境內基金',
				categoryId: 1,
				imgL: imgFundHeroL,
			},
			offshore: {
				pathName: '境外基金',
				categoryId: 2,
				imgL: imgFundHeroL,
			},
			etf: {
				pathName: 'ETF',
				categoryId: 3,
				imgL: imgEtfHeroL,
			},
		};
	}, []);

	const category = useMemo(() => {
		const { pathname } = location;

		if (pathname.includes('onshore')) return 'onshore';
		if (pathname.includes('offshore')) return 'offshore';
		if (pathname.includes('etf')) return 'etf';
	}, [location]);

	const isSales = useMemo(() => {
		return location.pathname.includes('_sales');
	}, [location]);

	const { list } = useStockList();

	const categoryList = useMemo(() => {
		const groupedByCategories = groupBy(list, 'ec001');
		const result = groupedByCategories[dict[category]?.categoryId];

		return result || [];
	}, [list, dict, category]);

	const [currentType, setCurrentType] = useState('');

	const groupedByType = useMemo(() => {
		const groupedFinal = {};

		groupedFinal['全部'] = categoryList;

		const grouped = groupBy(categoryList, 'ec020');
		const keys = Object.keys(grouped);

		each(keys, (key) => {
			groupedFinal[key] = grouped[key];
		});

		return groupedFinal;
	}, [categoryList]);

	const types = useMemo(() => {
		const result = Object.keys(groupedByType);
		if (result.length) setCurrentType(result[0]);
		return result;
	}, [groupedByType]);

	const currentList = useMemo(() => {
		const list = groupedByType[currentType] || [];
		// const sortedList = list.sort((a, b) => {
		// 	return a.sortValue - b.sortValue;
		// });
		return list;
	}, [groupedByType, currentType]);

	const [slideAllDown, setSlideAllDown] = useState(false);
	const [slideAllUp, setSlideAllUp] = useState(false);

	const toggleSlideAll = () => {
		if (slideAll) {
			setSlideAllDown(true);
			setTimeout(() => {
				setSlideAllDown(false);
			}, 100);
		} else {
			setSlideAllUp(true);
			setTimeout(() => {
				setSlideAllUp(false);
			}, 100);
		}

		setSlideAll(!slideAll);
	};

	const { routeData } = props;
	const { breadcrumbs } = useArticles(routeData.guid, routeData.route);

	return (
		<div className='FundList'>
			<Meta data={routeData} />

			{isSales ? null : <Hero data={breadcrumbs} />}

			<Breadcrumbs data={breadcrumbs} />

			<div className='common-pad-wrap'>
				<div className='category-tabs'>
					<Link to='/fund/offshore' className={`tab ${dict[category].pathName === '境外基金' && 'active'}`}>
						境外基金
					</Link>

					<div className='separator'></div>

					<Link to='/fund/onshore' className={`tab ${dict[category].pathName === '境內基金' && 'active'}`}>
						境內基金
					</Link>

					<div className='separator'></div>

					<Link to='/fund/etf' className={`tab ${dict[category].pathName === 'ETF' && 'active'}`}>
						ETF
					</Link>
				</div>
			</div>

			<div className='search-box'>
				<div className='group'>
					<div className='group-title'>基金類型</div>

					<select
						className='category'
						onChange={(event) => {
							setCurrentType(event.target.value);
						}}>
						{types.map((type) => {
							return (
								<option key={type} value={type}>
									{type}
								</option>
							);
						})}
					</select>
				</div>

				<div className='toggle-control l'>
					<div className='controller' onClick={toggleSlideAll}>
						<div className='icon'>
							<img src={iconList} alt='' />
						</div>
						<div className='text'>{slideAll ? '全部展開' : '全部收合'}</div>
					</div>
				</div>
			</div>

			<div className='toggle-control m'>
				<div className='controller' onClick={toggleSlideAll}>
					<div className='icon'>
						<img src={iconList} alt='' />
					</div>
					<div className='text'>{slideAll ? '全部展開' : '全部收合'}</div>
				</div>
			</div>

			<div className='result'>
				{currentList?.map((item, index) => {
					const { twName, enName, result, ec314 } = item;

					return (
						<SlideToggle
							key={item.guid}
							duration={300}
							easeCollapse={bezier}
							easeExpand={bezier}
							collapsed={index && true}
							expandEvent={slideAllDown}
							collapseEvent={slideAllUp}
							render={({ toggle, setCollapsibleElement, toggleState }) => (
								<div className='item'>
									<div className='head'>
										<div className='name'>
											{ec314 === 1 ? <div className='hot'>hot</div> : null}
											<div className='twName' onClick={toggle}>
												{twName}
											</div>
											<div className='enName'>{enName}</div>
										</div>
										<div className='icon-wrap' onClick={toggle}>
											<div className={`icon ${toggleState}`}></div>
										</div>
									</div>

									<div className='toggle-target' ref={setCollapsibleElement}>
										<div className='table-wrap'>
											<table>
												<thead>
													<tr>
														<th className='left'>基金級別</th>
														<th>幣別</th>
														<th>淨值日期</th>
														<th>最新淨值</th>
														<th>與前日漲跌幅(%)</th>
														<th>每單位配息</th>
														<th>快捷</th>
													</tr>
												</thead>

												<tbody>
													{result.map((resultItem) => {
														const { ec018, ec006, navDate, nav, changeRange, ec01022, fundID } = resultItem;

														let condition = '';

														if (changeRange > 0) condition = 'bull';
														if (changeRange < 0) condition = 'bear';

														const change = (changeRange * 100).toFixed(2).replace('-', '');

														return (
															<tr key={resultItem.id}>
																<td className='left'>
																	<Link
																		to={{
																			pathname: `${location.pathname}/${fundID}`,
																			state: {
																				parent: item,
																				parentPath: location.pathname,
																				parentPathName: dict[category]?.pathName,
																				fund: resultItem,
																			},
																		}}
																		className='link'>
																		{ec018}
																	</Link>
																</td>
																<td>{ec006}</td>
																<td>{navDate}</td>
																<td>{nav}</td>
																<td>
																	<div className={`range ${condition}`}>
																		<div className='text'>{change}%</div>
																		<div className='icon'></div>
																	</div>
																</td>
																<td>{ec01022}</td>
																<td>
																	<Link
																		className='link-to-graph'
																		to={{
																			pathname: `${location.pathname}/${fundID}`,
																			state: {
																				// parent: item,
																				// parentPath: location.pathname,
																				// parentPathName: dict[category]?.pathName,
																				// fund: resultItem,
																				tab: 'data',
																			},
																		}}>
																		<div className='icon'></div>
																		<div className='text'>淨值走勢</div>
																	</Link>
																</td>
															</tr>
														);
													})}
												</tbody>
											</table>
										</div>
									</div>
								</div>
							)}
						/>
					);
				})}
			</div>
		</div>
	);
};

export default FundList;
